<template>
  <div class="winners">
    <h2 class="winners__heading">
      {{ $t('winners.heading') }}
    </h2>
    <div class="winners__container">
      <div class="box box--map">
        <div class="text-sm font-bold">
          {{ $t('winners.sub-heading-map') }}
        </div>
        <div class="mt-14">
          <DefaultMap
            :last-draw="lastWinningDraw"
          />
        </div>
      </div>

      <div class="winners__boxes">
        <div v-if="todayPrize" class="box box--md w-full">
          <div>
            {{ $t('winners.copy-win-today') }}
          </div>
          <div class="text-highlighted font-bold">
            {{ todayPrize }}
          </div>
        </div>
        <div v-if="totalPrize" class="box box--md w-full">
          <div>
            {{ $t('winners.copy-win-summary') }}
          </div>
          <div class="text-highlighted font-bold">
            {{ totalPrize }}
          </div>
        </div>
      </div>

    </div>
    <div class="mt-6">
      <DefaultTable
        :items="gameDrawsStore.draws"
        :is-loading="gameDrawsStore.isLoading"
        :disable-next-page-button="disableNextPageButton"
        @next-page="loadNextPage"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const logger = useFrontendLogger()
const gameDrawsStore = useGameDrawsStore('list')
const gameStore = useGamesStore('stats')
const config = useRuntimeConfig()
const currency = useCurrency()

const itemsPerPage = config.public.winnersTableItemsPerPage || 8
const filters = {
  onlyFinished: true
}

const fetchDraws = async () => {
  try {
    await gameDrawsStore.fetchGameDraws(filters)
  } catch (e) {
    logger.error(e)
  }
}

const fetchStatistics = async () => {
  try {
    await gameStore.fetchStatistics()
  } catch (e) {
    logger.error(e)
  }
}

/**
 * Load next page event
 */
const loadNextPage = () => {
  gameDrawsStore.setOffset(gameDrawsStore.offset + gameDrawsStore.limit)
  fetchDraws()
}

/**
 * Disable next page button
 */
const disableNextPageButton = computed(() => {
  if (!gameDrawsStore.isLoading && gameDrawsStore.draws.length < (gameDrawsStore.offset + gameDrawsStore.limit)) {
    return true
  }
  return false
})

const lastWinningDraw = computed(() => {
  return gameDrawsStore.draws.find((draw) => {
    return draw.winningPsc && draw.region
  })
})

const todayPrize = computed(() => {
  if (gameStore.stats?.todayPrize && gameStore.stats?.todayPrize > 0) {
    return currency.toCurrency(gameStore.stats?.todayPrize)
  }
  return null
})

const totalPrize = computed(() => {
  if (gameStore.stats?.totalPrize && gameStore.stats?.totalPrize > 0) {
    return currency.toCurrency(gameStore.stats?.totalPrize)
  }
  return null
})

// load statistics
await fetchStatistics()
// load last draws data
gameDrawsStore.setOffset(0)
gameDrawsStore.setLimit(itemsPerPage)
await fetchDraws()

</script>